import { format } from 'date-fns';
import allLocales from '../constants/locale.constants';
import useSitecoreContext from './useSitecoreContext';

export default function useFormatDate(dateString?: string): string | undefined {
  const { sitecoreContext } = useSitecoreContext();

  if (!dateString) return dateString;

  const defaultDateFormat = 'dd MMMM yyyy';
  const { dateFormat = defaultDateFormat, dateLocal } = sitecoreContext?.regionalSettings || {};
  const date = new Date(dateString);
  const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  const locale = allLocales[dateLocal];
  let formattedDate: string;

  try {
    formattedDate = format(new Date(utcDate), dateFormat, locale && { locale });
  } catch (error) {
    formattedDate = format(new Date(utcDate), defaultDateFormat, locale && { locale });
  }

  return formattedDate;
}
